$ = jQuery;
var colorGuide = {};
var win = $(window);
var doc = $(document);

colorGuide = {
	defaults: {
	},
	onInit: function() {
		var vm = this;
	},
	onReady: function(e) {
		var vm = this;
		var el = vm.defaults;
		vm.onInit();
		vm.onResize();

		vm.toggleReadMore();
		vm.toggleSwatchSwitcher();
		vm.swatchSwitcherSideScroll();
		vm.onCarouselEdgeHit();
		// vm.popularCarouselInit();
		// vm.artPairingsCarouselInit();
		// vm.mainProductsCarouselInit();
		// vm.inspirationBlogsCarouselInit();

		vm.artPairingsCarouselInit();
		vm.mainProductsCarouselInit();
		vm.inspirationBlogsCarouselInit();
		vm.popularCarouselInit();
	},
	onLoad: function(e) {
		var vm = this;
		var el = vm.defaults;
	},
	onResize: function(e) {
		var vm = this;

		/* OLD CAROUSEL TRIGGER - 29 - Nov 2022 (unslicks the carousels on desktop viewport)
		if ($(window).width() < 1100) {
			if (!$('.swatch-fd-section-wrapper .pop-pairings-row').hasClass('slick-initialized')) {
				vm.popularCarouselInit();
			}
		} else {
			if ($('.swatch-fd-section-wrapper .pop-pairings-row').hasClass('slick-initialized')) {
				$('.swatch-fd-section-wrapper .pop-pairings-row').slick('unslick');
				$('.swatch-fd-section-wrapper .pop-pairings-row').removeClass('slick-initialized slick-slider slick-dotted');
			}
		}

		if ($(window).width() < 1432) {
			if (!$('.swatch-fd-section-wrapper .art-pairings-row').hasClass('slick-initialized')) {
				vm.artPairingsCarouselInit();
			}
			if (!$('.swatch-fd-section-wrapper .main-products-row').hasClass('slick-initialized')) {
				vm.mainProductsCarouselInit();
			}
			if (!$('.inspiration-section-wrapper .inspiration-row').hasClass('slick-initialized')) {
				vm.inspirationBlogsCarouselInit();
			}
		} else {
			if ($('.swatch-fd-section-wrapper .art-pairings-row').hasClass('slick-initialized')) {
				$('.swatch-fd-section-wrapper .art-pairings-row').slick('unslick');
				$('.swatch-fd-section-wrapper .art-pairings-row').removeClass('slick-initialized slick-slider slick-dotted');
			}
			if ($('.swatch-fd-section-wrapper .main-products-row').hasClass('slick-initialized')) {
				$('.swatch-fd-section-wrapper .main-products-row').slick('unslick');
				$('.swatch-fd-section-wrapper .main-products-row').removeClass('slick-initialized slick-slider slick-dotted');
			}
			if ($('.inspiration-section-wrapper .inspiration-row').hasClass('slick-initialized')) {
				$('.inspiration-section-wrapper .inspiration-row').slick('unslick');
				$('.inspiration-section-wrapper .inspiration-row').removeClass('slick-initialized slick-slider slick-dotted');
			}
		}
		*/
	},
	onScroll: function(e) {
		var vm = this;
		var st = win.scrollTop();

		if (st > vm.defaults.lastScrollTop) {
			// scroll down
		} else {
			// scroll up
		}

		vm.defaults.lastScrollTop = st;
	},
	toggleReadMore: function() {
		var vm = this;

		$('.cta-read-more').on('click', function() {
			let thisParentWrapper = $(this).parent();
			if (thisParentWrapper.hasClass('expand')) {
				thisParentWrapper.removeClass('expand');
				$(this).text('Read more');
			} else {
				thisParentWrapper.addClass('expand');
				$(this).text('Read less');
			}
		})
	},
	toggleSwatchSwitcher: function() {
		$('.swatch-fd-section-wrapper .mobile-color-switcher').on('click', function() {
			let thisParentWrapper = $(this).parent();
			if (thisParentWrapper.hasClass('expand')) {
				thisParentWrapper.removeClass('expand');
			} else {
				thisParentWrapper.addClass('expand');
			}
		});
	},
	popularCarouselInit: function() {
		$('.swatch-fd-section-wrapper .pop-pairings-row').each(function() {
			let thisCarousel = $(this);
			let showDots = true;
			let slideCount = thisCarousel.find('.product-tile').length;
			let slidesToShowCount = slideCount < 5 ? slideCount : 4;
			let slidesToShowMobile = 2;
			if (slideCount < 5 && slideCount != 1) {
				showDots = false;
				$('.swatch-fd-section-wrapper .pop-pairings-row').addClass('no-offset');
			} else if (slideCount == 1) {
				showDots = false;
				slidesToShowCount = 1;
				$('.swatch-fd-section-wrapper .pop-pairings-row').addClass('no-offset single-slide');
			}

			thisCarousel.slick({
				dots: false,
				infinite: false,
				slidesToShow: slidesToShowCount,
				slidesToScroll: 1,
				arrows: true,
				responsive: [
					{
						breakpoint: 1433,
						settings: {
							dots: false,
							infinite: false,
							slidesToShow: slidesToShowCount,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1101,
						settings: {
							dots: false,
							infinite: false,
							slidesToShow: slidesToShowMobile,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 768,
						settings: {
							dots: true,
							arrows: false,
							infinite: false,
							slidesToShow: slidesToShowMobile,
							slidesToScroll: 1
						}
					}
				]
			});
		});
	},
	artPairingsCarouselInit: function() {
		let showDots = true;
		let slideCount = $('.swatch-fd-section-wrapper .art-pairings-row .product-tile').length;
		let slidesToShowCount = slideCount < 5 ? slideCount : 4;
		let slidesToShowMobile = 2;

		if (slideCount < 5 && slideCount != 1) {
			showDots = false;
			$('.swatch-fd-section-wrapper .art-pairings-row').addClass('no-offset');
		} else if (slideCount == 1) {
			showDots = false
			slidesToShowCount = 1;
			$('.swatch-fd-section-wrapper .art-pairings-row').addClass('no-offset single-slide');
		}
		$('.swatch-fd-section-wrapper .art-pairings-row').slick({
			dots: false,
			infinite: false,
			slidesToShow: slidesToShowCount,
			slidesToScroll: 1,
			arrows: true,
			responsive: [
				{
					breakpoint: 1433,
					settings: {
						dots: false,
						infinite: false,
						slidesToShow: slidesToShowCount,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 1101,
					settings: {
						dots: false,
						infinite: false,
						slidesToShow: slidesToShowMobile,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						dots: true,
						arrows: false,
						infinite: false,
						slidesToShow: slidesToShowMobile,
						slidesToScroll: 1
					}
				}
			]
		});
	},
	mainProductsCarouselInit: function() {
		let showDots = true;
		let slideCount = $('.swatch-fd-section-wrapper .main-products-row .product-tile').length;
		let slidesToShowCount = slideCount < 5 ? slideCount : 4;
		let slidesToShowMobile = 2;
		if (slideCount < 5 && slideCount != 1) {
			showDots = false;
			$('.swatch-fd-section-wrapper .main-products-row').addClass('no-offset');
		} else if (slideCount == 1) {
			showDots = false
			slidesToShowCount = 1;
			slidesToShowMobile = 1;
			$('.swatch-fd-section-wrapper .main-products-row').addClass('no-offset single-slide');
		}
		$('.swatch-fd-section-wrapper .main-products-row').slick({
			dots: false,
			infinite: false,
			slidesToShow: slidesToShowCount,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous"></button>`,
			nextArrow: `<button class="slick-next slick-arrow" aria-label="Next"></button>`,
			responsive: [
				{
					breakpoint: 1433,
					settings: {
						dots: false,
						infinite: false,
						slidesToShow: slidesToShowCount,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 1101,
					settings: {
						dots: false,
						infinite: false,
						slidesToShow: slidesToShowMobile,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 768,
					settings: {
						dots: true,
						arrows: false,
						infinite: false,
						slidesToShow: slidesToShowMobile,
						slidesToScroll: 1
					}
				}
			]
		});
	},
	inspirationBlogsCarouselInit: function() {
		let showDots = true;
		let slideCount = $('.inspiration-section-wrapper .inspiration-row .blog-inspiration').length;
		let slidesToShowCount = slideCount < 5 ? slideCount : 4;
		if (slideCount < 5 && slideCount != 1) {
			showDots = false;
			$('.inspiration-section-wrapper .inspiration-row').addClass('no-offset');
		} else if (slideCount == 1) {
			showDots = false
			slidesToShowCount = 1;
			$('.inspiration-section-wrapper .inspiration-row').addClass('no-offset single-slide');
		}
		$('.inspiration-section-wrapper .inspiration-row').slick({
			dots: showDots,
			infinite: false,
			slidesToShow: slidesToShowCount,
			slidesToScroll: 1,
			arrows: false,
			responsive: [
				{
					breakpoint: 1433,
					settings: {
						dots: showDots,
						infinite: false,
						slidesToShow: slidesToShowCount,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 1101,
					settings: {
						dots: showDots,
						infinite: false,
						slidesToShow: 2,
						slidesToScroll: 1
					}
				},
				{
					breakpoint: 481,
					settings: {
						dots: showDots,
						infinite: false,
						slidesToShow: 1,
						slidesToScroll: 1
					}
				}
			]
		});
	},
	onCarouselEdgeHit: function() {
		console.log('edge func');
		$('.inspiration-section-wrapper .inspiration-row').on('beforeChange', function(event, slick, currentSlide, nextSlide){
			if (nextSlide == (slick.currentSlide + 1)) {
				$('.inspiration-section-wrapper .inspiration-row').find('.slick-list').addClass('edge-hit');
			} else {
				$('.inspiration-section-wrapper .inspiration-row').find('.slick-list').removeClass('edge-hit');
			}
		});
	},
	swatchSwitcherSideScroll: function() {
		const slider = document.querySelector('.color-icons-wrapper .color-icons-row');
		let isDown = false;
		let startX;
		let scrollLeft;

		if (!slider) {
			return false;
		}

		slider.addEventListener('mousedown', (e) => {
			isDown = true;
			slider.classList.add('active');
			startX = e.pageX - slider.offsetLeft;
			scrollLeft = slider.scrollLeft;
		});
		slider.addEventListener('mouseleave', () => {
			isDown = false;
			slider.classList.remove('active');
		});
		slider.addEventListener('mouseup', () => {
			isDown = false;
			slider.classList.remove('active');
		});
		slider.addEventListener('mousemove', (e) => {
			if(!isDown) return;
			e.preventDefault();
			const x = e.pageX - slider.offsetLeft;
			const walk = (x - startX) * 3; //scroll-fast
			slider.scrollLeft = scrollLeft - walk;
			console.log(walk);
		});
	}
};

doc.ready(function() {
	colorGuide.onReady();
});

win.on('load', function() {
	colorGuide.onLoad();
});

win.resize(function() {
	colorGuide.onResize();
});

win.scroll(function() {
	colorGuide.onScroll();
});

$(window).bind("pageshow", function(event) {
	if (event.originalEvent.persisted) {
		updateCartDrawer();
	}
});